import React from "react";
import styled from "styled-components";
import LinkIcon from "src/components/icons/Link";

const StyledDiv = styled("div")`
    color: ${(props) => props.theme.palette.primary.main};
`;

const StyledLink = styled("a")`
    color: ${(props) => props.theme.palette.primary.main};
`;

interface Props {
    documentUrl?: string;
    documentTitle?: string;
}

const DocumentLink = ({ documentUrl, documentTitle }: Props) => {
    if (documentTitle === undefined || documentUrl === undefined) {
        return null;
    }

    return (
        <StyledDiv className={`accessories_media_link_row`}>
            <LinkIcon />
            <StyledLink
                className={`accessories_media_link`}
                target="_blank"
                rel="noopener noreferrer"
                href={documentUrl}
            >
                {documentTitle}
            </StyledLink>
        </StyledDiv>
    );
};

export default DocumentLink;
